import ModalComponent from '@components/common/Modal';
import { IReflect } from '@models/Log';
import AdminLogApi from 'apis/api/AdminLog';
import React, { useEffect, useState } from 'react';
import { Descriptions, Tag, Divider } from 'antd';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { FaPaperclip } from 'react-icons/fa';
import moment from 'moment';
import envStore from '@utils/env';

interface IModalDetailReflect {
  rowSelect?: IReflect;
  isOpen: boolean;
  callBackClose: () => any;
  callBackRefresh?: () => any;
}

// Hàm tạo Tag màu cho priority
const getPriorityTag = (priorityValue: string) => {
  const colorMap: Record<string, string> = {
    '0': 'default', // Chỉ để tham khảo
    '1': 'default', // Chỉ để tham khảo
    '2': 'blue', // Xem xét trong thời gian tới
    '3': 'purple', // Mức trung bình, nên xử lý sớm
    '4': 'orange', // Nghiêm trọng, cần xử lý gấp
    '5': 'red' // Rất nghiêm trọng, xử lý khẩn cấp
  };

  const found = options2.find(opt => opt.value === priorityValue);
  return found ? (
    <Tag color={colorMap[priorityValue] || 'default'}>
      <span>{found.label || 'Không xác định'}</span>
    </Tag>
  ) : (
    <Tag color={'default'}>
      <span>{'Không xác định'}</span>
    </Tag>
  );
};

const options: any[] = [
  { label: 'Báo cáo sự việc/sự cố', value: '1' },
  { label: 'Góp ý cải thiện quy trình/chính sách', value: '2' },
  { label: 'Ý tưởng sáng tạo', value: '3' },
  { label: 'Vấn đề về môi trường làm việc', value: '4' },
  { label: 'Khác (ghi rõ trong nội dung)', value: '5' }
];

const options2: any[] = [
  { label: '1 – Chỉ để tham khảo', value: '1' },
  { label: '2 – Xem xét trong thời gian tới', value: '2' },
  { label: '3 – Mức trung bình, nên xử lý sớm', value: '3' },
  { label: '4 – Nghiêm trọng, cần xử lý gấp', value: '4' },
  { label: '5 – Rất nghiêm trọng, xử lý khẩn cấp', value: '5' }
];

const options3: any[] = [
  // { label: 'Phòng PNC', value: 'PNC' },
  // { label: 'Phòng CSKH', value: 'CSKH' },
  // { label: 'Phòng Kinh doanh', value: 'KD' },
  // { label: 'Phòng Kỹ thuật', value: 'KTH' },
  // { label: 'Phòng Sản xuất', value: 'SX' },
  // { label: 'Phòng Kế toán', value: 'KTO' }
  { label: 'Phòng Nghiên cứu', value: 'PNC' },
  { label: 'Phòng Chăm sóc khách  hàng', value: 'CSKH' },
  { label: 'Phòng Kinh doanh', value: 'KD' },
  { label: 'Phòng Kỹ thuật', value: 'KTH' },
  { label: 'Phòng Sản xuất', value: 'SX' },
  { label: 'Phòng Kế toán', value: 'KTO' },
  { label: 'Chi nhánh Hà Nội', value: 'CNHN' },
  { label: 'Chi nhánh Đà Nẵng', value: 'CNDN' },
  { label: 'Chi nhánh Cần Thơ', value: 'CNCT' },
  { label: 'Không xác định', value: 'OTHER' }
];

// Hàm map nhiều code sang label
const mapCodesToTags = (codes: string, opts: any[], type?: string) => {
  if (!codes) return <Tag color="default">Không xác định</Tag>;
  if (type === 'color') {
    return codes
      .split(';')
      .map(v => v.trim())
      .map(code => {
        const found = opts.find(opt => opt.value === code);
        return found ? (
          <div className="my-1" key={code}>
            {getPriorityTag(found.value)}
          </div>
        ) : null;
      });
  } else {
    return codes
      .split(';')
      .map(v => v.trim())
      .map(code => {
        const found = opts.find(opt => opt.value === code);
        return found ? (
          <Tag className="my-1" key={code}>
            {found.label}
          </Tag>
        ) : null;
      });
  }
};

const ModalDetailReflect = (props: IModalDetailReflect) => {
  const [data, setData] = useState<any>();

  const handleCancel = () => props.callBackClose();

  const fetchDetail = async () => {
    try {
      const res = await AdminLogApi.GetListReflectDetailById(props.rowSelect?.id);
      if (res.data.data) setData(res.data.data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (props.rowSelect?.id) {
      fetchDetail();
    }
  }, [props.rowSelect?.id]);

  const handleDownload = async () => {
    try {
      const fixedUrl = data.fileUrl.replace(/\\/g, '/');
      const fullUrl = `${envStore.apiBaseUrl}${fixedUrl}`;

      // envStore.apiBaseUrl}/${props.data.Picture
      const res = await fetch(fullUrl, { method: 'GET' });
      if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);

      const blob = await res.blob();

      // Lấy tên file từ URL
      const fileName = fixedUrl.split('/').pop() || 'downloaded_file.zip';

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();

      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error('Lỗi tải file:', err);
    }
  };

  return (
    <ModalComponent
      centered
      modalTitle="Chi tiết phản hồi"
      modalType="cancel"
      modalSize="medium"
      hiddenFooter
      visible={props.isOpen}
      onCancel={handleCancel}
    >
      {data && (
        <div className="p-2 mb-4">
          {/* <div className="grid grid-cols-[100px_1fr] gap-x-4 gap-y-2 p-2">
            <div className="font-semibold">Tiêu đề:</div>
            <div>{data.title || <i>Chưa có</i>}</div>

            <div className="font-semibold">Phòng ban:</div>
            <div>{mapCodesToTags(data.department, options3)}</div>

            <div className="font-semibold">Loại phản hồi:</div>
            <div>{mapCodesToTags(data.type, options)}</div>

            <div className="font-semibold">Mức độ ưu tiên / nghiêm trọng:</div>
            <div>{mapCodesToTags(data.priority, options2)}</div>

            <div className="col-span-2 border-t my-2" />

            <div className="font-semibold">Nội dung:</div>
            <div
              dangerouslySetInnerHTML={{
                __html: data.content || '<i>Chưa có</i>'
              }}
            />

            <div className="font-semibold">Giải pháp:</div>
            <div>{data.resolve || <i>Chưa có</i>}</div>
          </div> */}

          <Descriptions bordered column={1} size="small">
            <Descriptions.Item label="Tiêu đề">{data.title}</Descriptions.Item>
            <Descriptions.Item label="Phòng ban">{mapCodesToTags(data.department, options3)}</Descriptions.Item>
            <Descriptions.Item label="Loại phản ánh">{mapCodesToTags(data.type, options)}</Descriptions.Item>
            <Descriptions.Item label="Mức độ ưu tiên">
              {mapCodesToTags(data.priority, options2, 'color')}
            </Descriptions.Item>
            <Descriptions.Item label="Tệp đính kèm">
              {data.fileUrl ? (
                <>
                  {/* <div className="col-span-2 border-t my-2" /> */}
                  {/* Tệp đính kèm:{' '} */}
                  <button
                    onClick={handleDownload}
                    className="text-blue-500 hover:underline flex items-center justify-center"
                  >
                    <FaPaperclip className="mr-1" /> Tải xuống
                  </button>
                </>
              ) : (
                ''
              )}
            </Descriptions.Item>
            <Descriptions.Item label="Ngày tạo">
              {moment(data.createTime).format('HH:mm:ss DD/MM/YYYY')}
            </Descriptions.Item>
          </Descriptions>

          <Divider />

          <Descriptions bordered column={1} size="small" className="mb-4 lg:mb-0">
            <Descriptions.Item label="Nội dung">
              <div dangerouslySetInnerHTML={{ __html: data.content || 'Chưa có' }} />
            </Descriptions.Item>
            <Descriptions.Item label="Đề xuất xử lý ">{data.resolve || 'Chưa có'}</Descriptions.Item>
          </Descriptions>

          {/* <div>
            {data.fileUrl ? (
              <>
                <div className="col-span-2 border-t my-2" />
                Tệp đính kèm:{' '}
                <button
                  onClick={handleDownload}
                  className="text-blue-500 hover:underline flex items-center justify-center"
                >
                  <FaPaperclip className="mr-1" /> Tải xuống
                </button>
              </>
            ) : (
              ''
            )}
          </div> */}

          {/* <Descriptions bordered column={1} size="small">
            <Descriptions.Item label="Tiêu đề">{data.title}</Descriptions.Item>
            <Descriptions.Item label="Phòng ban">{mapCodesToTags(data.department, options3)}</Descriptions.Item>
            <Descriptions.Item label="Loại phản ánh">{mapCodesToTags(data.type, options)}</Descriptions.Item>
            <Descriptions.Item label="Mức độ ưu tiên">{mapCodesToTags(data.priority, options2)}</Descriptions.Item>
          </Descriptions>

          <Divider />

          <Descriptions bordered column={1} size="small">
            <Descriptions.Item label="Nội dung">
              <div dangerouslySetInnerHTML={{ __html: data.content || 'Chưa có' }} />
            </Descriptions.Item>
            <Descriptions.Item label="Giải pháp">{data.resolve || 'Chưa có'}</Descriptions.Item>
          </Descriptions> */}
        </div>
      )}
    </ModalComponent>
  );
};

export default ModalDetailReflect;
